import { IUserNotification } from '@tableau/user-notifications-client-core';
import { ButtonType,ButtonWidget } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../commonInfra/utils/ImgUrl';
import { UserNotificationActions } from '../redux/UserNotificationActions';
import { NotificationCenterStyles } from '../styles/notificationCenterStyles';
import { sendUserNotificationsCenterTelemetry, UserNotificationsTelemetryEvents } from '../telemetry/UserNotificationsTelemetry';
import { NotificationDisplayMode } from './NotificationPanel';

export type NotificationPanelHeaderProps = {
  userPreferenceUrl: string;
  isMarkAllReadDisabled: boolean;
  userNotificationActions: UserNotificationActions;
  userNotifications: _.Dictionary<IUserNotification<any>>;
  displayMode: NotificationDisplayMode;
  closePanel: () => void;
  userId: string;
  siteLuid: string;
  updateMarkAllAsReadClickTime: (currentTime: number) => void;
};

export const NotificationPanelTitleDomId = 'notification-panel-title';

export class NotificationPanelHeader extends React.PureComponent<NotificationPanelHeaderProps> {

  constructor(props: NotificationPanelHeaderProps) {
    super(props);
    this.markAllAsRead = this.markAllAsRead.bind(this);
  }

  private markAllAsRead() {
    this.props.updateMarkAllAsReadClickTime(performance.now());
    sendUserNotificationsCenterTelemetry(UserNotificationsTelemetryEvents.markAllAsRead, this.props.userId, this.props.siteLuid);
    const ids = _.keys(_.pick(this.props.userNotifications, (value: IUserNotification<any>) => !value.read));
    this.props.userNotificationActions.updateUserNotificationsStatus(ids, true);
  }

  private handleUserSettingLinkClick = (): void => {
    sendUserNotificationsCenterTelemetry(UserNotificationsTelemetryEvents.clickUserSettingsLink, this.props.userId, this.props.siteLuid);
    this.props.closePanel();
  };

  public render() {

    return <div id={'notification-panel-header'} className={NotificationCenterStyles.notificationPanelHeaderContainer}>
      <h4 id={NotificationPanelTitleDomId} style={{ marginLeft: 4 }}>{Messages.userNotificationsLabel()}</h4>
      {
        (this.props.displayMode === NotificationDisplayMode.NotificationLoading) ? <span /> :
          <div>
            {
              !this.props.isMarkAllReadDisabled &&
                <ButtonWidget
                  buttonType={ButtonType.LowEmphasis}
                  onClick={this.markAllAsRead}
                  testId='mark-all-read-button'
                >
                  {Messages.userNotificationMenuMarkAllAsRead()}
                </ButtonWidget>
            }
            <a href={this.props.userPreferenceUrl}
              tabIndex={0} title={Messages.settings()}
              className={NotificationCenterStyles.userPreferenceLink}
              data-tb-test-id='notification-usersetting-link'
              onClick={this.handleUserSettingLinkClick}
            >
              <img src={imgPath('spaces_navigation_admin_settings.svg')} alt={Messages.userNotificationSettingsIconAlt()} />
            </a>
          </div>
      }
    </div>;
  }

}
